import { Route } from 'react-router-dom'
import { Routes } from '../Routes'
import { AdminDungeons, AdminDungeonNew, AdminDungeonEdit } from 'containers'

export const AdminDungeonRouter = () => {
  return (
    <Routes>
      <Route path="/new"       element={<AdminDungeonNew />} />
      <Route path="/:id/edit"  element={<AdminDungeonEdit />} />
      <Route path="/"          element={<AdminDungeons />} />
    </Routes>
  )
}
